import { useMemo, useState } from "react";
import axiosInstance from "../axiosinstance";
import "./FirmRegistrationForm.css";

import { useNavigate } from "react-router-dom";
const initialFormState = {
  firm_name: "",
  owner_name: "",
  contact_no: "",
  email_id: "",
  address_line1: "",
  address_line2: "",
  city: "",
  state: "",
  country: "",
  pincode: "",
  logo: null,
};

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const FirmRegistrationForm = ({
  planId,
  planName,
  planAmount,
  onCancel,
  onRegistered,
}) => {
  const [formData, setFormData] = useState(initialFormState);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState("");
  const [submitType, setSubmitType] = useState("success");
  const [pincodeLoading, setPincodeLoading] = useState(false);
  const [existingFirmData, setExistingFirmData] = useState(null);
  const [currentStep, setCurrentStep] = useState(1);
  const [isAlreadyRegistered, setIsAlreadyRegistered] = useState(false);
  const [isFirmFullyRegistered, setIsFirmFullyRegistered] = useState(false);
  const [pincodeError, setPincodeError] = useState("");
  const [address, setAddress] = useState({
    city: "",
    state: "",
  });
const fetchPincodeDetails = async (pincode) => {
  try {
    setPincodeLoading(true);
    setPincodeError("");
    const response = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
    const data = await response.json();
    if (data[0].Status === "Success") {
      const postOffice = data[0].PostOffice[0];
      setAddress((prev) => ({
        ...prev,
        city: postOffice.District,
        state: postOffice.State,
      }));
      
      setFormData((prev) => ({
        ...prev,
        city: postOffice.District,
        state: postOffice.State,
        country: postOffice.Country
      }));
    } else {
      setPincodeError("Invalid pincode");
      setAddress((prev) => ({ ...prev, city: "", state: "" }));
    }
  } catch {
    setPincodeError("Could not fetch details, please enter manually");
  } finally {
    setPincodeLoading(false);
  }
};
  const logoLabel = useMemo(() => {
    if (!formData.logo) return "Upload firm logo (optional)";
    return formData.logo.name;
  }, [formData.logo]);

  const handleFieldChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    

setErrors((prev) => ({ ...prev, [field]: "" }));
    if (currentStep === 1) {
    setIsAlreadyRegistered(false);
    setExistingFirmData(null);
    setIsFirmFullyRegistered(false);
  }
  };

  const validateStep1 = () => {
    const nextErrors = {};

    if (!formData.firm_name.trim()) nextErrors.firm_name = "Firm Name is required";
    if (!formData.owner_name.trim()) nextErrors.owner_name = "Owner Name is required";
    if (!formData.contact_no.trim()) nextErrors.contact_no = "Contact Number is required";
    if (!formData.email_id.trim()) nextErrors.email_id = "Email Address is required";

    if (formData.email_id.trim() && !emailRegex.test(formData.email_id.trim())) {
      nextErrors.email_id = "Enter a valid email address";
    }

    if (formData.contact_no.trim() && !/^\d{10}$/.test(formData.contact_no.trim())) {
      nextErrors.contact_no = "Contact Number must be 10 digits";
    }

    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const validateStep2 = () => {
    const nextErrors = {};

    if (!formData.address_line1.trim()) {
      nextErrors.address_line1 = "Address Line 1 is required";
    }
    if (!formData.city.trim()) nextErrors.city = "City is required";
    if (!formData.state.trim()) nextErrors.state = "State is required";
    if (!formData.country.trim()) nextErrors.country = "Country is required";
    if (!formData.pincode.trim()) nextErrors.pincode = "Pincode is required";
    if (!planId) nextErrors.plan_id = "Unable to continue: plan is missing";

    if (formData.pincode.trim() && !/^\d{6}$/.test(formData.pincode.trim())) {
      nextErrors.pincode = "Pincode must be 6 digits";
    }

    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };
  const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};
let navigate = useNavigate()

  const handleNext = async () => {
    if (isSubmitting) return;
  if (!isAlreadyRegistered && !validateStep1()) return; 
    
    setSubmitMessage("");
    setSubmitType("success");
    setIsFirmFullyRegistered(false);

    const payload = new FormData();
    payload.append("firm_name", formData.firm_name.trim());
    payload.append("owner_name", formData.owner_name.trim());
    payload.append("contact_no", formData.contact_no.trim());
    payload.append("email_id", formData.email_id.trim());

    try {
      setIsSubmitting(true);
      const response = await axiosInstance.post("/api/check-firm-basic-details", payload, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      const message = response?.data?.message || "";

      if (message === "Firm already registered. Please login.") {
        setIsFirmFullyRegistered(true);
        setIsAlreadyRegistered(false);
        return;
      } else if (message === "Registration already started. Continue payment.") {
        setIsAlreadyRegistered(true);
        setIsFirmFullyRegistered(false);
        setExistingFirmData(response.data);
      } else {
        setIsAlreadyRegistered(false);
        setCurrentStep(2);
      }
    } catch (error) {
      const message = error?.response?.data?.message || "";
      
      if (message === "Firm already registered. Please login.") {
        setIsFirmFullyRegistered(true);
        setIsAlreadyRegistered(false);
      } else if (message === "Registration already started. Continue payment.") {
        setIsFirmFullyRegistered(false);
        setIsAlreadyRegistered(true);
      } else if (message === "A firm with this name is already registered.") {
        setSubmitType("error");
        setSubmitMessage(message || "A firm with this name is already registered.");
      } else if (message) {
        setIsFirmFullyRegistered(false);
        setIsAlreadyRegistered(false);
        setCurrentStep(2)
      } else {
        setSubmitType("error");
        setSubmitMessage(message || "Unable to validate firm details right now.");
      }
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleContinuePayment = async () => {
  if (isSubmitting) return;

  const loaded = await loadRazorpayScript();
  if (!loaded) {
    setSubmitType("error");
    setSubmitMessage("Razorpay failed to load. Check your internet connection.");
    
    return;
  }

  try {
    setIsSubmitting(true);

    let razorpayOrder;
    
    if (existingFirmData.existing_order) {
      // Order already exists, use it directly
      razorpayOrder = existingFirmData.existing_order;
    } else {
      // No existing order, create a new one
      let formData = new FormData();
      formData.append("firm_id", existingFirmData.firm_id);
      const orderRes = await axiosInstance.post("/api/create-subscription-order", formData);
      razorpayOrder = orderRes.data.razorpay_order;
    }

    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY,
      amount: razorpayOrder.amount,
      currency: razorpayOrder.currency,
      name: "Office Allign",
      description: "Test Transaction",
      order_id: razorpayOrder.id,
      handler: async function (razorpayResponse) {
        try {
        const verifyRes = await axiosInstance.post("/api/verify-payment", {
          razorpay_order_id: razorpayResponse.razorpay_order_id,
          razorpay_payment_id: razorpayResponse.razorpay_payment_id,
          razorpay_signature: razorpayResponse.razorpay_signature,
        });
        if (verifyRes.data.message === "Payment verified successfully") {
          navigate("/login");
        } else {
          setSubmitType("error");
    setSubmitMessage("❌ Payment Verification Failed.");
        }
      } catch (error) {
        setSubmitType("error");
    setSubmitMessage("❌ Payment Verification Failed.");
        return;
      }
        
      },
      theme: {
        color: "#3399cc",
      },
    };
    console.log(options)
    const rzp = new window.Razorpay(options);
    rzp.open();

  } catch (error) {
    const message = error?.response?.data?.message || "Failed to initiate payment.";
    setSubmitType("error");
    setSubmitMessage(message);
  } finally {
    setIsSubmitting(false);
  }
};
  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitMessage("");

    if (isSubmitting) return;
  if (!isAlreadyRegistered && !validateStep2()) return;
    const loaded = await loadRazorpayScript();

  if (!loaded) {
    setSubmitType("error");
    setSubmitMessage("Razorpay failed to load. Check your internet connection.");
    return;
  }
    const payload = new FormData();
    payload.append("firm_name", formData.firm_name.trim());
    payload.append("owner_name", formData.owner_name.trim());
    payload.append("address_line1", formData.address_line1.trim());
    payload.append("address_line2", formData.address_line2.trim());
    payload.append("city", formData.city.trim());
    payload.append("state", formData.state.trim());
    payload.append("country", formData.country.trim());
    payload.append("pincode", formData.pincode.trim());
    payload.append("contact_no", formData.contact_no.trim());
    payload.append("email_id", formData.email_id.trim());
    payload.append("plan_id", planId);

    if (formData.logo) {
      payload.append("logo", formData.logo);
    }

    try {
      setIsSubmitting(true);
      const response = await axiosInstance.post("/api/register-firm", payload, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      
      const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY,
      amount: response.data.razorpay_order.amount,
      currency: response.data.razorpay_order.currency,
      name: "Office Allign",
      description: "Test Transaction",
      order_id: response.data.razorpay_order.id,
      handler: async function (razorpayResponse) { // ← rename to avoid clash
      const verifyRes = await axiosInstance.post("/api/verify-payment", {
        razorpay_order_id: razorpayResponse.razorpay_order_id,
        razorpay_payment_id: razorpayResponse.razorpay_payment_id,
        razorpay_signature: razorpayResponse.razorpay_signature,
      });
      
      if (verifyRes.data.message === "Payment verified successfully") {
       navigate("/login")
        
      } else {
        setSubmitType("error");
    setSubmitMessage("❌ Payment Verification Failed.");
       
     
        
      }
    },
      theme: {
        color: "#3399cc",
      },
    };
    
    const rzp = new window.Razorpay(options);
    rzp.open();
      const firmId = response.data?.firm_id || "";
      const message = response.data?.message || "Registration completed.";
      const type = response.status === 200 ? "info" : "success";

      setSubmitType(type);
      setSubmitMessage(message);

      if (onRegistered) {
        onRegistered({
          status: response.status,
          firm_id: firmId,
          message,
        });
      }

    } catch (error) {
      
      const message =
        error?.response?.data?.message || "Failed to complete registration.";
      setSubmitType("error");
      setSubmitMessage(message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="firm-reg-modal-overlay" role="dialog" aria-modal="true">
      <div className="firm-reg-modal">
        <div className="firm-reg-header">
          <div>
            <p className="firm-reg-eyebrow">ANNUAL ACCESS ENROLLMENT</p>
            <h3>Complete Firm Registration</h3>
            <p className="firm-reg-subtitle">
              Fill in your firm details to continue payment for{" "}
              <strong>{planName || "selected plan"}</strong>.
            </p>
          </div>
          <button
            type="button"
            className="firm-reg-close-btn"
            onClick={onCancel}
            disabled={isSubmitting}
            aria-label="Close registration form"
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="firm-reg-form">
          <div className="firm-reg-progress">
            <div className={`firm-reg-step ${currentStep === 1 ? "active" : ""}`}>
              Step 1: Firm Details
            </div>
            <div className="firm-reg-step-line" />
            <div className={`firm-reg-step ${currentStep === 2 ? "active" : ""}`}>
              Step 2: Address & Payment
            </div>
          </div>

          {currentStep === 1 && (
            <>
              <div className="firm-reg-section">
                <h4>Firm Information</h4>
                <div className="firm-reg-grid">
                  <div className="firm-reg-field">
                    <label>Firm Name*</label>
                    <input
                      type="text"
                      value={formData.firm_name}
                      onChange={(e) => handleFieldChange("firm_name", e.target.value)}
                      className="firm-reg-input"
                    />
                    {errors.firm_name && <p className="firm-reg-error">{errors.firm_name}</p>}
                  </div>
                  <div className="firm-reg-field">
                    <label>Owner Name*</label>
                    <input
                      type="text"
                      value={formData.owner_name}
                      onChange={(e) => handleFieldChange("owner_name", e.target.value)}
                      className="firm-reg-input"
                    />
                    {errors.owner_name && (
                      <p className="firm-reg-error">{errors.owner_name}</p>
                    )}
                  </div>
                </div>
                <div className="firm-reg-field">
                  <label>Logo Upload</label>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => handleFieldChange("logo", e.target.files?.[0] || null)}
                    className="firm-reg-file-input"
                  />
                  <p className="firm-reg-file-label">{logoLabel}</p>
                </div>
              </div>

              <div className="firm-reg-section">
                <h4>Contact Information</h4>
                <div className="firm-reg-grid">
                  <div className="firm-reg-field">
                    <label>Contact Number*</label>
                    <input
                      type="text"
                      maxLength={10}
                      value={formData.contact_no}
                      onChange={(e) =>
                        handleFieldChange(
                          "contact_no",
                          e.target.value.replace(/\D/g, "").slice(0, 10)
                        )
                      }
                      className="firm-reg-input"
                    />
                    {errors.contact_no && (
                      <p className="firm-reg-error">{errors.contact_no}</p>
                    )}
                  </div>
                  <div className="firm-reg-field">
                    <label>Email Address*</label>
                    <input
                      type="email"
                      value={formData.email_id}
                      onChange={(e) => handleFieldChange("email_id", e.target.value)}
                      className="firm-reg-input"
                    />
                    {errors.email_id && <p className="firm-reg-error">{errors.email_id}</p>}
                  </div>
                </div>
              </div>
              {isFirmFullyRegistered && (
                <p className="firm-reg-submit-msg info">Your firm is already registered. Please Login.</p>
              )}
            </>
          )}

          {currentStep === 2 && (
            <div className="firm-reg-section">
              <h4>Address Information</h4>
              <div className="firm-reg-field">
                <label>Address Line 1*</label>
                <input
                  type="text"
                  value={formData.address_line1}
                  onChange={(e) => handleFieldChange("address_line1", e.target.value)}
                  className="firm-reg-input"
                />
                {errors.address_line1 && (
                  <p className="firm-reg-error">{errors.address_line1}</p>
                )}
              </div>
              <div className="firm-reg-field">
                <label>Address Line 2</label>
                <input
                  type="text"
                  value={formData.address_line2}
                  onChange={(e) => handleFieldChange("address_line2", e.target.value)}
                  className="firm-reg-input"
                />
              </div>
              <div className="firm-reg-grid">
                <div className="firm-reg-field">
                  <label>City*</label>
                  <input
                    type="text"
                    value={formData.city}
                    onChange={(e) => handleFieldChange("city", e.target.value)}
                    className="firm-reg-input"
                  />
                  {errors.city && <p className="firm-reg-error">{errors.city}</p>}
                </div>
                <div className="firm-reg-field">
                  <label>State*</label>
                  <input
                    type="text"
                    value={formData.state}
                    onChange={(e) => handleFieldChange("state", e.target.value)}
                    className="firm-reg-input"
                  />
                  {errors.state && <p className="firm-reg-error">{errors.state}</p>}
                </div>
                <div className="firm-reg-field">
                  <label>Country*</label>
                  <input
                    type="text"
                    value={formData.country}
                    onChange={(e) => handleFieldChange("country", e.target.value)}
                    className="firm-reg-input"
                  />
                  {errors.country && <p className="firm-reg-error">{errors.country}</p>}
                </div>
                <div className="firm-reg-field">
                  <label>Pincode* (Enter pincode to auto-fill location details.)</label>
                   <input
                    type="text"
                    maxLength={6}
                    value={formData.pincode}
                    onChange={(e) =>{
                      handleFieldChange(
                        "pincode",
                        e.target.value.replace(/\D/g, "").slice(0, 6)
                      )
                      const val = e.target.value.replace(/\D/g, "").slice(0, 6); // digits only, max 6
                    setAddress((prev) => ({ ...prev, postalCode: val }));
                    if (val.length === 6) fetchPincodeDetails(val);
                    if (val.length < 6) {
                      // clear city and state if user edits pincode
                      setAddress((prev) => ({ ...prev, city: "", state: "" }));
                    }
                    }}
                    className="firm-reg-input"
                  />
                  {errors.pincode && <p className="firm-reg-error">{errors.pincode}</p>}
                </div>
              </div>
            </div>
          )}

          {errors.plan_id && <p className="firm-reg-error">{errors.plan_id}</p>}
          {submitMessage && (
            <p className={`firm-reg-submit-msg ${submitType}`}>{submitMessage}</p>
          )}

          <div className="firm-reg-actions">
            {currentStep === 1 ? (
              <>
                <button
                  type="button"
                  className="firm-reg-cancel-btn"
                  onClick={onCancel}
                  disabled={isSubmitting}
                >
                  Cancel
                </button>
                {isFirmFullyRegistered ? (
                <button
                  type="button"
                  className="firm-reg-submit-btn"
                  onClick={() => navigate("/login")}
                  disabled={isSubmitting}
                >
                  Login
                </button>
              ) : isAlreadyRegistered ? (
                <button
                  type="button"
                  className="firm-reg-submit-btn"
                  onClick={handleContinuePayment}
                  disabled={isSubmitting}
                >
                  Make Payment
                </button>
              ) : (
                <button
                  type="button"
                  className="firm-reg-submit-btn"
                  onClick={handleNext}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Checking..." : "Next →"}
                </button>
              )}
              </>
            ) : (
              <>
                <button
                  type="button"
                  className="firm-reg-cancel-btn"
                  onClick={() => setCurrentStep(1)}
                  disabled={isSubmitting}
                >
                 Back
                </button>
                <button type="submit" className="firm-reg-submit-btn" disabled={isSubmitting}>
                  {isSubmitting
                    ? "Submitting..."
                    : "Complete Registration & Pay"}
                </button>
              </>
            )}
          </div>
        </form>
      </div>
      
    </div>
  );
};

export default FirmRegistrationForm;
